
/* eslint-disable no-undef */
const ELCA_COLOS_LOG = '[ElcaCoLOS]';
window.ElcaColosWidget = window.ElcaColosWidget || {};
const disableAttributeProperty = 'disabled';

$('document').ready(function () {
    try {
        ElcaColosWidget.completePageLoading();
    }
    catch (e) {
        console.error('completePageLoading failed internally, but event bindings will still work.', e);
    }
});

ElcaColosWidget.completePageLoading = function() {
    ElcaColosWidget.toogleRegistrationSucceededMessage();
    ElcaColosWidget.toogleActivationCodeSucceededMessage();
    ElcaColosWidget.toogleDownloadSucceededMessage();
};

$(document).on('submit', '.needs-validation', function (event) {
    const form = this;
    event.preventDefault();

    if (form.checkValidity() === false ||
        $(this).find('input[name=\'completed_captcha\']').val() != 'valid') {
        event.stopPropagation();
        form.classList.add('was-validated');
    }

            if (grecaptcha != undefined && grecaptcha != null) {
        grecaptcha.reset();
    }
});

$(document).on('click', '#mi-corpo-colos-new-registration-tab, #mi-corpo-colos-download-tab, #mi-corpo-colos-activate-forgot-tab', function () {
    ElcaColosWidget.hidePreviousMessages();
});

$(document).on('click', '#mi-corpo-colos-new-registration-button', function () {
    ElcaColosWidget.registerNewUser();
});

$(document).on('click', '#mi-corpo-colos-activation-code', function () {
    ElcaColosWidget.getActivationCode();
});

$(document).on('click', '#mi-corpo-colos-get-versions', function (e) {
    e.preventDefault();
    e.stopPropagation();

    ElcaColosWidget.getAvaliableVersions();

    const downVersion = $('#Down_Version').val();
    if (downVersion != undefined && downVersion != '') {
        $('.mi-corpo-colos-packages').prop(disableAttributeProperty, false);
    }
});

$(document).on('click', '#mi-corpo-colos-download-form-button', function (e) {
    e.preventDefault(); // Prevents button from firing unexpected form behaviors
    ElcaColosWidget.downloadFiles();
});

$(document).on('click', '#mi-corpo-colos-pre-checkbox', function () {
    $('#mi-corpo-colos-pre-button').prop(disableAttributeProperty, !$(this).prop('checked'));
});

$(document).on('click', '#mi-corpo-colos-pre-button', function () {
    $('.mi-corpo-colos-new-registration-content-hidden').addClass('mi-corpo-colos-new-registration-content');
    $('.mi-corpo-colos-new-registration-content').removeClass('mi-corpo-colos-new-registration-content-hidden');

    $('.mi-corpo-colos-info-announce-hidden').addClass('mi-corpo-colos-info-announce');
    $('.mi-corpo-colos-info-announce').removeClass('mi-corpo-colos-info-announce-hidden');

    $('.mi-corpo-colos-new-registration-agreement').hide();
});

$(document).on('click', '#mi-corpo-colos-success-announce-new-registration button, #mi-corpo-colos-success-announce-activation-code button, #mi-corpo-colos-success-announce-download-form button', function () {
    ElcaColosWidget.backToBasePage();
});

$(document).on('blur change', 'input[type="text"], textarea', function (e) {
    const $this = $(this);
    const trimmedValue = $this.val().trim();

    if (trimmedValue === $this.val()) {
        e.preventDefault();
        return false;
    }
 else {
        $this.val(trimmedValue);
        $this.change();
    }
});

ElcaColosWidget.backToBasePage = function() {
    window.location.reload();
};

ElcaColosWidget.hidePreviousMessages = function() {
    $('.mi-corpo-colos-message-announce').hide();
};

ElcaColosWidget.toogleRegistrationSucceededMessage = function() {
    $('#mi-corpo-colos-success-announce-new-registration').toggle();
};

ElcaColosWidget.toogleActivationCodeSucceededMessage = function() {
    $('#mi-corpo-colos-success-announce-activation-code').toggle();
};

ElcaColosWidget.toogleDownloadSucceededMessage = function() {
    $('#mi-corpo-colos-success-announce-download-form').toggle();
};

/**
 * Animated scroll to given selector.
 *
 * @param {string} selector
 *   Given selector.
 * @param {int} [offset].
 *   Optional offset. Default is 50.
 * @returns {undefined}
 */
ElcaColosWidget.makeScreenGoToElement = function(selector, offset) {
    offset = typeof offset !== 'undefined' ? offset : 50;
    $('html, body').animate({
        scrollTop: $(selector).offset().top - offset
    });
};

ElcaColosWidget.renderResponseByStatusCode = function(statusCode, message) {
    if (statusCode != 200) {
        $('.mi-corpo-colos-message').text(message);
        $('.mi-corpo-colos-message-announce').css('display', 'flex');
        ElcaColosWidget.makeScreenGoToElement('#mi-corpo-colos-form-tabs');
    }
    else {
        ElcaColosWidget.hidePreviousMessages();
        $('#mi-corpo-colos-form-tabs').toggle();
        $('#mi-corpo-colos-form-tabs-content').toggle();
    }
};

ElcaColosWidget.renderInternalServerError = function(errorMessage) {
    ElcaColosWidget.renderResponseByStatusCode(500, errorMessage);
};

ElcaColosWidget.parseAndRenderResponse = function(serializedResponse) {
    const response = serializedResponse.responseText
        ? JSON.parse(serializedResponse.responseText)
        : JSON.parse(serializedResponse);

    ElcaColosWidget.renderResponseByStatusCode(response.ResponseCode, response.Message);

    return response;
};

ElcaColosWidget.geoLocalizationCOLOS = function() {
    $.getJSON('https://api.ipify.org?format=json',
        function(data) {
            $.getJSON('/Sitefinity/Public/Services/GeoLocation/GeoLocation.svc/' + data.ip, function() {})
                .done(function(userIpCountry) {
                const jsonParse = JSON.parse(userIpCountry);

                if (jsonParse.ErrorMessage) {
                        console.error(ELCA_COLOS_LOG, labelColosUserLocationError);  // eslint-disable-line no-console
                    }
                    else {
                    ElcaColosWidget.saveAccessAndCheckAllowedCountry(
                        jsonParse.Ip,
                        jsonParse.GeoLocationDateTime,
                        jsonParse.IsoCode,
                        jsonParse.Country,
                        jsonParse.City,
                        jsonParse.Region
                    );
                    return userIpCountry;
                }
            })
                .fail(function() {
                })
                .always(function() {
                $('#mi-corpo-loading-image').css('display', 'none');
            });
    });
};

ElcaColosWidget.saveAccessAndCheckAllowedCountry = function(ip, dateTime, isocode, country, city, region) {
    const queryString = '?'
        + $('.mi-corpo-CoLOS-hidden-data-form').serialize()
        + '&ip=' + ip
        + '&dateTime=' + dateTime
        + '&isocode=' + isocode
        + '&country=' + country
        + '&city=' + city
        + '&region=' + region
        + '&lang=' + document.documentElement.lang;

    new AsyncRequestManager().renderSyncRequest('/CoLOS/saveAccessAndCheckAllowedCountry', queryString, '#mi-corpo-colos-form');
};

ElcaColosWidget.registrationFieldsFilled = function(registerData) {
    const isMandatoryDataComplete =
        registerData.firstname != '' &&
        registerData.lastname != '' &&
        registerData.companyName != '' &&
        registerData.country != '' &&
        registerData.email != '' &&
        registerData.chkTerms;

    return isMandatoryDataComplete;
};

ElcaColosWidget.registerNewUser = function () {
    const registerData = {
        firstname: $('#Reg_Firstname').val(),
        lastname: $('#Reg_Lastname').val(),
        companyName: $('#Reg_CompanyName').val(),
        country: $('#SelectCountry option:selected').val(),
        email: $('#Reg_Email').val().trim(),
        chkTerms: $('#chkTerms').prop('checked')
    };

    if (!ElcaColosWidget.registrationFieldsFilled(registerData)) {
        ElcaColosWidget.renderInternalServerError(labelColosMissingMandatoryFields);
        return;
    }

    const $invalidRecaptcha = $('#mi-corpo-colos-registration-invalid-recaptcha');

    if ($('#mi-corpo-colos-register-captcha').val() != 'valid') {
        $invalidRecaptcha.show();
        ElcaColosWidget.renderInternalServerError(labelColosMissingRecaptcha);
        return;
    }

    $invalidRecaptcha.hide();

    $.ajax({
        url: '/CoLOS/GetNewRegistration',
        async: false,
        data: registerData,
        type: 'PUT',
        success: function (result) {
            const response = ElcaColosWidget.parseAndRenderResponse(result);

            if (response.ResponseCode == 200) {
                ElcaColosWidget.toogleRegistrationSucceededMessage();
            }
        },
        error: function () {
            ElcaColosWidget.renderInternalServerError(labelColosRegisterError);
        }
    });
};

ElcaColosWidget.generateJsonLink = function (jsonString) {
    const jsonBlob = new Blob([jsonString], { type: 'application/json' });
    const jsonUrl = URL.createObjectURL(jsonBlob);

    const jsonLink = document.createElement('a');
    jsonLink.href = jsonUrl;
    jsonLink.target = '_blank';
    jsonLink.download = 'activationCode.json';

    return jsonLink;
};

ElcaColosWidget.displayJsonLink = function (jsonLink) {
    return '<a href="' + jsonLink.href + '" download="' + jsonLink.download + '" target="' + jsonLink.target + '">' + labelDownloadActivationFile + '</a>';
};

ElcaColosWidget.downloadJson = function (jsonLink) {
    jsonLink.click();
};

ElcaColosWidget.processSuccessfulActivation = function(serializedResponse, isDownloadOptionASeparateStep) {
    const response = ElcaColosWidget.parseAndRenderResponse(serializedResponse);

    if (response.ResponseCode == 200) {
        ElcaColosWidget.toogleActivationCodeSucceededMessage();
        const responseMessage = JSON.parse(response.Message);

        if (isDownloadOptionASeparateStep) {
            $('#mi-corpo-colos-activation-code-result')
                .html('<p style=\'color:var(--black)\'>' + labelColosActivationCodeValue + '</p> <b><p>' + responseMessage + '</p></b>');
        }
        else {
            let jsonLink = ElcaColosWidget.generateJsonLink(responseMessage);

            $('#mi-corpo-colos-activation-code-result')
                .html('<p style="color:var(--black)">' + labelColosActivationCodeAutomaticDownload + '</p>'
                    + '<p>' + labelColosActivationCodeManualDownload + ElcaColosWidget.displayJsonLink(jsonLink) + '</p></b>');

            ElcaColosWidget.downloadJson(jsonLink);
        }
    }
};

ElcaColosWidget.areActivationMandatoryDataCompleted = function (activationData) {
    return activationData.serialNumber != '' && activationData.registeredEmail != '' && activationData.trackingNumber != '';
};

ElcaColosWidget.getActivationCode = function() {
    const isDownloadOptionASeparateStep = $('#mi-corpo-colos-download-tab').length != 0;

    let activationData = {
        serialNumber: $('#Act_SerialNumber').val().trim(),
        trackingNumber: $('#Act_TrackingNumber').val().trim(),
        registeredEmail: $('#Act_registeredEmail').val().trim(),
        isDownloadOptionASeparateStep: isDownloadOptionASeparateStep
    };

    if (!ElcaColosWidget.areActivationMandatoryDataCompleted(activationData)) {
        ElcaColosWidget.renderInternalServerError(labelColosMissingMandatoryFields);
        return;
    }

    let $invalidRecaptcha = $('#mi-corpo-colos-activate-forgot-invalid-recaptcha');

    if ($('#mi-corpo-colos-activate-forgot-captcha').val() != 'valid') {
        $invalidRecaptcha.show();
        ElcaColosWidget.renderInternalServerError(labelColosMissingRecaptcha);
        return;
    }

    $invalidRecaptcha.hide();

    $.ajax({
        url: '/CoLOS/GetActivationCode',
        async: false,
        data: activationData,
        type: 'PUT',
        success: function (result) {
            ElcaColosWidget.processSuccessfulActivation(result, isDownloadOptionASeparateStep);
        },
        error: function () {
            ElcaColosWidget.renderInternalServerError(labelColosActivationCodeError);
        }
    });
};

ElcaColosWidget.getAvaliableVersions = function() {
    return $.ajax({
        url: '/CoLOS/GetVersions',
        async: false,
        data: { trackingNumber: $('#Down_TrackingNumber').val().trim() },
        type: 'PUT',
        success: function (result) {
            const jsonParse = JSON.parse(result);
            if (jsonParse.ResponseCode == 200) {
                ElcaColosWidget.hidePreviousMessages();

                // Remove options from selector and fill with the versions provided by the API
                const $versionPicker = $('.versionPicker');
                const listVersion = JSON.parse(jsonParse.Message);

                $versionPicker.find('option').remove();
                for (var i = 0; i < listVersion.length; i++) {
                    $versionPicker.append('<option value="' + listVersion[i] + '">' + listVersion[i] + '</option>');
                }

                const hasVersion7 = listVersion.some(function (version) {
                    return version.startsWith('7.0');
                });

                if (hasVersion7) {
                    $('.v7').css('display', 'block');
                }
                else {
                    $('.v7').css('display', 'none');
                }
            }
            else {
                $('.mi-corpo-colos-message').text(jsonParse.Message);
                $('.mi-corpo-colos-message-announce').css('display', 'flex');
            }
        },
        error: function (result) {
            const $colosMessage = $('.mi-corpo-colos-message');
            $colosMessage.val(JSON.parse(result).Message);
            $colosMessage.css('display', 'flex');
        }
    });
};

ElcaColosWidget.areDownloadMandatoryFieldsFilled = function (downloadData) {
    return downloadData.registeredEmail != '' && downloadData.packageType && downloadData.trackingNumber != '' && downloadData.versionNo != '';
};

ElcaColosWidget.packageTypesToDownload = function() {
    const packageTypesElements =
        ['#chkHelpPack', '#chkLanguagePack', '#chkSoftware', '#chkUserGuides', '#chkExtras', '#chkDriverPack', '#chkClientInstallers', '#chkSiteInstallers'];

    let packageTypesToDownload = [];

    packageTypesElements.forEach((packageTypeElement, index) => {

        if ($(packageTypeElement).prop('checked')) {
            packageTypesToDownload.push(index + 1);
        }

    });

    return packageTypesToDownload;
};

ElcaColosWidget.downloadFiles = function() {
    const downVersionValue = $('#Down_Version').val();
    const downloadData = {
        registeredEmail: $('#Down_Email').val().trim(),
        trackingNumber: $('#Down_TrackingNumber').val().trim(),
        versionNo: downVersionValue == undefined ? '' : downVersionValue.trim(),
        packageType: ElcaColosWidget.packageTypesToDownload().join()
    };

    if (ElcaColosWidget.areDownloadMandatoryFieldsFilled(downloadData)) {
        const $invalidRecaptcha = $('#mi-corpo-colos-download-invalid-recaptcha');

        if ($('#mi-corpo-colos-download-captcha').val() == 'valid') {
            $invalidRecaptcha.hide();
            $.ajax({
                url: '/CoLOS/Download',
                async: false,
                data: downloadData,
                type: 'PUT',
                success: function(result) {
                    const response = ElcaColosWidget.parseAndRenderResponse(result);
                    if (response.ResponseCode == 200) {
                        ElcaColosWidget.toogleDownloadSucceededMessage();
                        const href = response.DownloadURL || '';
                        $('#download-colos-link').attr('href', href);
                    }
                },
                error: function() {
                    ElcaColosWidget.renderInternalServerError(labelDownloadError);
                }
            });
        }
        else {
            $invalidRecaptcha.show();
            ElcaColosWidget.renderInternalServerError($('#ElcaColosResponseCodeCompleteGoogleRecaptcha').text());
        }
    }
    else {
        ElcaColosWidget.renderInternalServerError($('#ElcaColosResponseCodeRequiredFields').text());
    }
};

ElcaColosWidget.captchaRegistrationCallback = function() {
    if (grecaptcha.getResponse(0) !== '') {
        $('#mi-corpo-colos-register-captcha').val('valid');
    }
};

ElcaColosWidget.captchaActivationForgotCallback = function() {
    if (grecaptcha.getResponse(1) !== '') {
        $('#mi-corpo-colos-activate-forgot-captcha').val('valid');
    }
};

ElcaColosWidget.captchaDownloadCallback = function() {
    if (grecaptcha.getResponse(2) !== '') {
        $('#mi-corpo-colos-download-captcha').val('valid');
    }
};
